<template>
  <div class="semiology-container">
    <!-- Empty State -->
    <div v-if="data.length == 0" class="empty-state">
      <div class="empty-icon">
        <i class="fas fa-stethoscope"></i>
      </div>
      <h3 class="empty-title">Nenhuma semiologia validada</h3>
      <p class="empty-text">
        Você ainda não validou nenhuma semiologia. As validações aparecerão aqui
        quando realizadas.
      </p>
    </div>

    <!-- Semiology Table -->
    <div v-if="data.length > 0" class="semiology-table-container">
      <v-data-table
        dense
        :headers="headers"
        :items="data"
        item-key="id"
        :footer-props="{
          'items-per-page-options': [10, 25, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
        class="modern-table"
        :no-data-text="'Nenhum registro encontrado'"
        :loading-text="'Carregando...'"
      >
        <template v-slot:[`item.signature`]="{ item }">
          (Assinatura eletrônica)
          {{
            professionalClassCouncilValue({
              id: item.user_professional_class_council_id,
              name: item.user_name,
              profile: item.user_profile_name,
              cpf: item.user_cpf,
              office: item.user_office,
              value: item.user_professional_class_council_value,
            })
          }}
        </template>
        <template v-slot:[`item.resident_name`]="{ item }">
          {{ item.resident_name }}
        </template>
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:[`item.description`]="{ item }">
          {{ item.description }}
        </template>
        <template v-slot:[`item.user_name`]="{ item }">
          {{ item.user_name }}
        </template>
        <template v-slot:[`item.last_modified_date`]="{ item }">
          {{ formatDate(item.last_modified_date) }}
        </template>
        <template v-slot:[`item.location`]="{ item }">
          <LinkVerLocalizacaoRegistro
            :x_small="true"
            :item="{ ...item, id: `semiology-${item.id}` }"
          />
        </template>
        <template v-slot:[`item.certificate`]="{ item }">
          <ButtonGenerateCertificate
            :x_small="true"
            v-if="item.data_base64"
            :id="item.id"
            :data_base64="item.data_base64"
            :modal_id="`semiology-${item.id}`"
            text_button="Assinaturas"
          />
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import LinkVerLocalizacaoRegistro from "../Components/LinkVerLocalizacaoRegistro";
import ButtonGenerateCertificate from "../Components/ButtonGenerateCertificate";

import { formatDate, professionalClassCouncilValue } from "../../lib/format";

export default {
  name: "TechnicalResponsibleMyValidationsSemiology",

  components: {
    LinkVerLocalizacaoRegistro,
    ButtonGenerateCertificate,
  },

  props: {
    data: { type: Array },
    tableOptions: { type: [Array, Object] },
    total: { type: [Number, String] },
  },

  watch: {
    tableOptions: {
      handler() {
        this.options = this.tableOptions;
      },
    },

    options: {
      handler() {
        let { page, itemsPerPage } = this.options;

        this.$emit("paginate", { page, itemsPerPage });
      },
    },
  },

  data() {
    return {
      options: {},

      headers: [
        { text: "Assinatura", value: "signature", sortable: false },
        { text: "RESIDENTE", value: "resident_name", sortable: false },
        { text: "FORMULÁRIO", value: "name", sortable: false },
        { text: "DESCRIÇÃO", value: "description", sortable: false },
        { text: "AVALIADOR", value: "user_name", sortable: false },
        {
          text: "ÚLTIMA ALTERAÇÃO",
          value: "last_modified_date",
          sortable: false,
        },
        { text: "", value: "location", sortable: false },
        { text: "", value: "certificate", sortable: false },
      ],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    professionalClassCouncilValue,

    truncateText(text, limit) {
      if (!text) return "Sem observações";
      return text.length > limit ? text.substring(0, limit) + "..." : text;
    },

    async retrieve() {},
  },
};
</script>

<style scoped>
.semiology-container {
  width: 100%;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  background: #f8fafc;
  border-radius: 8px;
  border: 2px dashed #e5e7eb;
}

.empty-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 16px;
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #9ca3af;
}

.empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.empty-text {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.4;
}

/* Table Container */
.semiology-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.table-wrapper {
  overflow-x: auto;
}

/* Table Styles */
.semiology-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

/* Table Header */
.semiology-table thead {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
}

.semiology-table th {
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  color: #3730a3;
  font-size: 12px;
  border-bottom: 2px solid #818cf8;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.semiology-table th i {
  color: #4338ca;
  font-size: 11px;
}

/* Column Widths */
.th-resident {
  width: 20%;
}
.th-evaluation {
  width: 20%;
}
.th-evaluator {
  width: 15%;
}
.th-date {
  width: 12%;
}
.th-description {
  width: 23%;
}
.th-actions {
  width: 10%;
}

/* Table Body */
.semiology-table tbody tr {
  transition: all 0.2s ease;
}

.semiology-table tbody tr:nth-child(even) {
  background-color: #f8fafc;
}

.semiology-table tbody tr:hover {
  background-color: #e0e7ff;
  transform: scale(1.005);
}

.semiology-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: top;
}

/* Resident Cell */
.resident-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.resident-avatar {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #4338ca 0%, #3730a3 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  flex-shrink: 0;
}

.resident-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 13px;
  word-break: break-word;
}

/* Evaluation Info */
.evaluation-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.evaluation-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 12px;
  word-break: break-word;
}

.evaluation-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  background: rgba(67, 56, 202, 0.1);
  color: #4338ca;
  border-radius: 8px;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  border: 1px solid rgba(67, 56, 202, 0.2);
  width: fit-content;
}

/* Evaluator */
.evaluator-name {
  color: #374151;
  font-weight: 500;
  font-size: 12px;
  word-break: break-word;
}

/* Validated Date */
.validated-date {
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

/* Description Preview */
.description-preview {
  max-width: 200px;
}

.description-text {
  color: #374151;
  font-size: 11px;
  line-height: 1.3;
  word-break: break-word;
  font-style: italic;
}

/* Actions */
.td-actions {
  text-align: center;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .semiology-table {
    font-size: 12px;
  }

  .semiology-table th {
    padding: 8px 10px;
    font-size: 11px;
  }

  .semiology-table td {
    padding: 6px 10px;
  }

  .th-description {
    width: 25%;
  }
  .th-evaluation {
    width: 18%;
  }
  .th-resident {
    width: 22%;
  }
}

@media (max-width: 768px) {
  .semiology-table-container {
    border-radius: 6px;
  }

  .semiology-table {
    font-size: 11px;
  }

  .semiology-table th {
    padding: 6px 8px;
    font-size: 10px;
  }

  .semiology-table td {
    padding: 5px 8px;
  }

  .resident-avatar {
    width: 20px;
    height: 20px;
    font-size: 9px;
  }

  .resident-name {
    font-size: 12px;
  }

  .evaluation-name {
    font-size: 11px;
  }

  .evaluation-badge {
    font-size: 8px;
    padding: 1px 4px;
  }

  .evaluator-name {
    font-size: 11px;
  }

  .validated-date {
    font-size: 10px;
  }

  .description-text {
    font-size: 10px;
  }

  .description-preview {
    max-width: 150px;
  }
}

@media (max-width: 640px) {
  /* Stack table for mobile */
  .table-wrapper {
    overflow-x: scroll;
  }

  .semiology-table {
    min-width: 700px;
  }

  .th-description {
    width: 28%;
  }

  .th-resident {
    width: 25%;
  }

  .th-evaluation {
    width: 20%;
  }

  .th-evaluator {
    width: 15%;
  }

  .th-date {
    width: 10%;
  }

  .th-actions {
    width: 2%;
  }
}

@media (max-width: 480px) {
  .evaluation-info {
    gap: 2px;
  }

  .evaluation-name {
    font-size: 10px;
  }

  .evaluation-badge {
    font-size: 7px;
    padding: 1px 3px;
  }

  .description-preview {
    max-width: 120px;
  }

  .description-text {
    font-size: 9px;
  }
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.semiology-row {
  animation: fadeIn 0.3s ease-out;
}
</style>